$(document).ready(function(){


 

   // $('#tabs-nav li a:first-child').addClass('active');
  $('#tabs-nav li a:first').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();
  $('#tabs-nav li a').click(function(){
    $('#tabs-nav li a').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();

    var activeTab = $(this).attr('href');
  //  alert(activeTab)
    $('.tab-content').each(function(){
      var tab  = $(this).attr('href') ;
      //alert(tab);
      if(activeTab == tab ){
      $(this).fadeIn();
       // $('.tab-content').slick('refresh');
      }
    })

      return false;
  });

    $('textarea#preferences-textarea').on('input', function () {
      // Get the current value of the textarea
      var texInputValue = $(this).val();
      
      // Show the text input value in the UI
      $('.feild-prefence').val(texInputValue); 
      });
    // ---
       $(function() {
      $('.tabs-nav li:first').addClass('active');
      $('.tabs-nav a').click(function() {
    
        // Check for active
        $('.tabs-nav li').removeClass('active');
        $(this).parent().addClass('active');
    
        // Display active tab
        let currentTab = $(this).attr('href');
        $('.tabs-content div').hide();
        $(currentTab).show();
    
        return false;
      });
    });

   });



// product bundle js 

document.addEventListener('DOMContentLoaded', function() {
 //add button click
  document.addEventListener("click", function (event) {
    //add item
    if(event.target && event.target.matches('.add_btn')) { 

      
event.target.closest('li').classList.add('active_item_box');
   event.target.closest('li').classList.add('active_item_box');

    const image = event.target.closest('.pro_list').querySelector('.Bundle_box_image .product-image').getAttribute('src');
    const varName = event.target.closest('.pro_list').querySelector('.product_options select');
    let Varvalue = '';
    if (varName) {
        Varvalue = varName.options[varName.selectedIndex].text;
    }
    const title = event.target.closest('.pro_list').querySelector('.Bundle_box_title h5').innerHTML;
    const price = event.target.closest('.pro_list').querySelector('.Bundle_box_title p').innerHTML;
    const varId = event.target.closest('.pro_list').querySelector('.bundle_box_cart').getAttribute('data-varid');
    const qty_val = parseInt(event.target.closest('.pro_list').querySelector('.bundle_box_cart.remove_btn').getAttribute('data-qty'));

  //   var length_check = event.target
  // .closest('.pro_list')
  // .querySelectorAll('.selling-plan-group .selling-plan-option').length;
  //     console.log(length_check);
  //     if (length_check == 4) {
  //       console.log('yees 4');
  //       var sellingPlanOptions = event.target.closest('.pro_list').querySelectorAll('.selling-plan-group .selling-plan-option');
  //       var thirdSellingPlanOption = sellingPlanOptions[2];
  //       var sellingidweek = thirdSellingPlanOption.getAttribute('data-plan-id');

  //     //  const sellingPlanOptions = event.target.closest('.pro_list').querySelectorAll('.selling-plan-group .selling-plan-option');
        
  //       var nthSellingPlanOption = sellingPlanOptions[3]; 
  //       var sellingidmonth = nthSellingPlanOption.getAttribute('data-plan-id');
            
  //     } else {
  //       var sellingidweek = event.target.closest('.pro_list').querySelector('.selling-plan-group .selling-plan-option[data-selling-plan-name="Weekly"]').getAttribute('data-plan-id');
  //       var sellingidmonth = event.target.closest('.pro_list').querySelector('.selling-plan-group .selling-plan-option[data-selling-plan-name="Monthly"]'); 
  //       if (sellingidmonth){
  //       sellingidmonth.getAttribute('data-plan-id'); 
  //       }
  //      // var sellingidmonth = event.target.closest('.pro_list').querySelector('.selling-plan-group .selling-plan-option[data-selling-plan-name="Monthly"]').getAttribute('data-plan-id');  
  //         console.log('yees no');
  //     }

       var sellingidweek = event.target.closest('.pro_list').querySelector('.selling-plan-group .selling-plan-option[data-selling-plan-name="Weekly"]').getAttribute('data-plan-id');
      
  const data = {
        Title: title,
        Price: price,
        VarID: varId,
        Qty: qty_val,
        Image: image,
        week : sellingidweek,
       // month : sellingidmonth
    };

    if (Varvalue) {
        data.VariantName = Varvalue;
    }

    let products = JSON.parse(localStorage.getItem('product_data'));
    if (!Array.isArray(products)) {
        products = [];
    }

    const index = products.findIndex(product => product.VarID === varId);

    if (index !== -1) {
      if (qty_val == 1 ){
        products[index].Qty += qty_val; 
      }
      else{
          products[index].Qty = qty_val; 
      }
    } else {

        products.push(data);
    }

    localStorage.setItem('product_data', JSON.stringify(products));
  cartItem();
      
      
      const limit_product = event.target.closest('.active_step_box').getAttribute('data-product-limit');
      
      const countActiveItem = document.querySelectorAll('.active_step_box .active_item_box');
      if(countActiveItem.length <= limit_product ) {
        if(countActiveItem.length == limit_product){
          event.target.closest('.active_step_box').classList.add('stop_item_add');
        }else{
          event.target.closest('.active_step_box').classList.remove('stop_item_add');
        }
        document.querySelector('.error_mess').classList.remove('active_error');
      
        
      }else{
        event.target.closest('li').classList.remove('active_item_box');
      }
    }

    //remove item
    if(event.target && event.target.matches('.Bundle_box_title .remove_btn')) { 
      event.target.closest('li').classList.remove('active_item_box');
      event.target.closest('ul').classList.remove('stop_item_add');
      cartItem();
    }

    //bundle cart item remove
    if(event.target && event.target.matches('.hide_box_product')) { 
      let removeItemID = event.target.getAttribute('data-id');
      if(removeItemID){
        const items_line_check = document.querySelectorAll('.active_item_box');
        items_line_check.forEach(function(item) {
          const dataId = item.getAttribute('data-value');
          // alert(dataId);
          if (dataId == removeItemID) {
            item.querySelector('.remove_btn').click();
          }
        });
      }

    
        let products = JSON.parse(localStorage.getItem('product_data'));
        if (!Array.isArray(products)) {
            products = [];
        }
        const index = products.findIndex(product => product.VarID === removeItemID);
        if (index != -1) {
            products.splice(index, 1);
        } 
        localStorage.setItem('product_data', JSON.stringify(products));
          cartItem();
}
    
    
  });



const button_next = document.querySelector('.Next_choice');
if (button_next) {
  button_next.addEventListener('click', function() {
        const activeStepBox = document.querySelector('.active_step_box');
        const nextStepBox = activeStepBox.nextElementSibling;
        if (nextStepBox) {
          activeStepBox.classList.remove('active_step_box');
          nextStepBox.classList.add('active_step_box');
        }
        let step_check = document.querySelectorAll('.active_step_box');
        if(step_check){
          let id_step = step_check[0].getAttribute('data-step');
          let bottom_step = document.querySelectorAll('.step_toolbar li');
          bottom_step.forEach(function(step) {
            step.classList.remove('step_active');
            let idStep = step.getAttribute('data-step');
            if(idStep == id_step){
              step.classList.add('step_active');
            }
            
          });
        }

    $('html, body').animate({
        scrollTop: $('.Build_box_select').offset().top - 20 
    }, 500);
    
  });
}

const button_previous = document.querySelector('.Previous_choice');
if (button_previous) {
  button_previous.addEventListener('click', function() {
      const activeStepBox = document.querySelector('.active_step_box');
      const prevStepBox = activeStepBox.previousElementSibling;
      if (prevStepBox) {
        activeStepBox.classList.remove('active_step_box');
        prevStepBox.classList.add('active_step_box');
      }
      let step_check = document.querySelectorAll('.active_step_box');
        if(step_check){
          let id_step = step_check[0].getAttribute('data-step');
          let bottom_step = document.querySelectorAll('.step_toolbar li');
          bottom_step.forEach(function(step) {
            step.classList.remove('step_active');
            let idStep = step.getAttribute('data-step');
            if(idStep == id_step){
              step.classList.add('step_active');
            }
            
          });
        }
      $('html, body').animate({
        scrollTop: $('.Build_box_select').offset().top - 20 
    }, 500);
  });
}


 //add button click
function cartItem() {
  const items_line = document.querySelectorAll('.active_item_box');
  const cart_box_item = document.querySelector('.Bundle_item_box');
  // if(items_line){
    cart_box_item.innerHTML = '';
    let totlePrice = 0.00;
    let products = JSON.parse(localStorage.getItem('product_data'));
   if (Array.isArray(products)) {
    products.forEach(product => {
      let itemImg = product.Image;
      let itemName = product.Title;
      let itemPrice = product.Price;
      let itemQty = product.Qty;
      let itemId = product.VarID;
      let varName = product.VariantName;
      let itemweek = product.week;
      let itemmonth = product.month;
      
      // alert(varName);
      if(cart_box_item){
        cart_box_item.innerHTML += `<li class="Bundle_item_products" var-id="${itemId}" weekly-id="${itemweek}" monthly-id="${itemmonth}" data-qty="${itemQty}">
                  <div class="Bundle_box_image">
                    <img class="final_bundle_image" src="${itemImg}" alt="nj-gourmet-meal">
                  </div>
                  <div class="Bundle_box_title">
                    <h5>${itemName}</h5>
                     ${varName ? `<p class="varName">${varName}</p>` : ''}
                    <span>Qty: ${itemQty}</span>
                    <p>${itemPrice}</p>
                  </div>
                  <svg data-id="${itemId}" class="hide_box_product" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.53 9.53L14.06 13L17.53 16.47C17.6037 16.5387 17.6628 16.6215 17.7038 16.7135C17.7448 16.8055 17.7668 16.9048 17.7686 17.0055C17.7704 17.1062 17.7518 17.2062 17.7141 17.2996C17.6764 17.393 17.6203 17.4778 17.549 17.549C17.4778 17.6203 17.393 17.6764 17.2996 17.7141C17.2062 17.7518 17.1062 17.7704 17.0055 17.7686C16.9048 17.7668 16.8055 17.7448 16.7135 17.7038C16.6215 17.6628 16.5387 17.6037 16.47 17.53L13 14.06L9.53001 17.53C9.38783 17.6625 9.19978 17.7346 9.00548 17.7312C8.81118 17.7277 8.6258 17.649 8.48838 17.5116C8.35097 17.3742 8.27226 17.1888 8.26883 16.9945C8.2654 16.8002 8.33753 16.6122 8.47001 16.47L11.94 13L8.47001 9.53C8.33753 9.38782 8.2654 9.19978 8.26883 9.00548C8.27226 8.81118 8.35097 8.62579 8.48838 8.48838C8.6258 8.35097 8.81118 8.27225 9.00548 8.26882C9.19978 8.2654 9.38783 8.33752 9.53001 8.47L13 11.94L16.47 8.47C16.6122 8.33752 16.8002 8.2654 16.9945 8.26882C17.1888 8.27225 17.3742 8.35097 17.5116 8.48838C17.649 8.62579 17.7278 8.81118 17.7312 9.00548C17.7346 9.19978 17.6625 9.38782 17.53 9.53ZM25.75 13C25.75 15.5217 25.0022 17.9868 23.6012 20.0835C22.2003 22.1802 20.209 23.8144 17.8792 24.7795C15.5495 25.7445 12.9859 25.997 10.5126 25.505C8.03935 25.0131 5.76751 23.7987 3.98439 22.0156C2.20127 20.2325 0.986955 17.9607 0.494993 15.4874C0.00303191 13.0141 0.255524 10.4505 1.22054 8.12079C2.18556 5.79103 3.81976 3.79975 5.91648 2.39876C8.01321 0.997774 10.4783 0.25 13 0.25C16.3803 0.25397 19.621 1.59854 22.0112 3.98877C24.4015 6.379 25.746 9.61971 25.75 13ZM24.25 13C24.25 10.775 23.5902 8.59989 22.354 6.74984C21.1179 4.89978 19.3609 3.45784 17.3052 2.60636C15.2495 1.75487 12.9875 1.53208 10.8052 1.96617C8.62295 2.40025 6.6184 3.47171 5.04505 5.04505C3.47171 6.61839 2.40025 8.62295 1.96617 10.8052C1.53209 12.9875 1.75488 15.2495 2.60636 17.3052C3.45785 19.3609 4.89979 21.1179 6.74984 22.354C8.59989 23.5902 10.775 24.25 13 24.25C15.9827 24.2467 18.8422 23.0604 20.9513 20.9513C23.0604 18.8422 24.2467 15.9827 24.25 13Z" fill="black"></path>
                  </svg>
                </li>`;
      }
      let priceProduct = parseFloat(itemPrice.replace('$', '') * itemQty);
       priceProduct = parseFloat(priceProduct.toFixed(2));
      totlePrice += priceProduct;
      
    });
}
    
    
    const priceFinal = document.querySelector('.Final_total_price p');
    if(priceFinal){
      priceFinal.textContent = '$'+totlePrice.toFixed(2);
    }
  // }
}


//add to cart
const addToCart = document.querySelector('.add_to_cart_final');
if (button_previous) {
  addToCart.addEventListener('click', function() {   
          const Product_item = [];
          const selectedValue = document.querySelector('.Bundle_purchase_option input:checked').value;
          if(selectedValue == 'subscribe'){
            const frequency_check = document.querySelector('.appstle_select');
            const frequency_value = frequency_check.value;
            if(frequency_value){
              let selling_plan = document.querySelectorAll('.Build_box_final .Bundle_item_box .Bundle_item_products');
              if(selling_plan){
                selling_plan.forEach(function(sellingItems) {
                  //let selling_plan_name = sellingItems.getAttribute('data-selling-plan-name');
                 // alert(frequency_value);
                  let plan_id;
                  if (frequency_value == "Weekly"){
                     plan_id = sellingItems.getAttribute('weekly-id');
                  } else if (frequency_value == "Monthly"){
                    plan_id = sellingItems.getAttribute('monthly-id');
                  }
                    let variant_id = sellingItems.getAttribute('var-id');
                    let Qty = sellingItems.getAttribute('data-qty');
                    Product_item.push({ id: variant_id, selling_plan: plan_id, quantity: Qty });
                  console.log({ id: variant_id, selling_plan: plan_id, quantity: Qty });
                });
              }
            }
          }
          if (Product_item.length > 0) {
          let pre_loader = document.querySelector('.itg_loader_main');
          pre_loader.style.display = 'block';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: Product_item
            })
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Error adding products to the cart');
            }
            return response.json();
          })
          .then(data => {
            pre_loader.style.display = 'none';
               fetch(`${routes.cart_url}`).then((response) => response.text()).then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  var header_count = html.querySelector('#cart-icon-bubble').innerHTML;
                  document.querySelector('#cart-icon-bubble').innerHTML = header_count;  
              }).catch((e) => {
                console.error(e);
                // location.href = "/checkout";
              });
             document.querySelector('.product_added_notification').style.display = 'block';
          //  location.href = "/checkout";
          })
          
          }else{
            document.querySelector('.error_mess').classList.add('active_error');
          }
  });
}

    // Plus Button Logic
    $('.bundle_plus').on('click', function () {
      var input = $(this).closest('li').find('.custom_quantity');
      var maxValue = input.attr('max');
        var inputValue = parseInt(input.val());
        if (inputValue < maxValue) {
            var add_qty = inputValue + 1;
                input.val(add_qty);
                var input_val = $(this).closest('li').find('.custom_quantity').val();
                if(input_val != ''){
                  $(this).closest('li').find('.remove_btn').attr('data-qty',input_val);
                  $(this).closest('li').find('.selling-plan-option').attr('data-qty',input_val);
                }  
               
             const varId = event.target.closest('.pro_list').querySelector('.bundle_box_cart').getAttribute('data-varid');
    const qty_val = parseInt(event.target.closest('.pro_list').querySelector('.bundle_box_cart.remove_btn').getAttribute('data-qty'));
    const data = {
        Qty: qty_val
    };


    let products = JSON.parse(localStorage.getItem('product_data'));
    if (!Array.isArray(products)) {
        products = [];
    }

    const index = products.findIndex(product => product.VarID === varId);

    if (index != -1) {
      if (qty_val === 1 ){
        products[index].Qty += qty_val; 
      }
      else{
          products[index].Qty = qty_val; 
      }
    } 

    localStorage.setItem('product_data', JSON.stringify(products));
           cartItem();
        }
    });

    // Minus Button Logic (prevent going below minValue)
    $('.bundle_minus').on('click', function () {
      var input = $(this).closest('li').find('.custom_quantity');
      var minValue = input.attr('min');
        var inputValue = parseInt(input.val());
        if (inputValue > minValue) {
            input.val(inputValue - 1);
            var input_val = $(this).closest('li').find('.custom_quantity').val();
            if(input_val != ''){
              $(this).closest('.active_step_box').removeClass('stop_item_add'); 
              $(this).closest('li').find('.remove_btn').attr('data-qty',input_val);
              $(this).closest('li').find('.selling-plan-option').attr('data-qty',input_val);
            }
               const varId = event.target.closest('.pro_list').querySelector('.bundle_box_cart').getAttribute('data-varid');
    const qty_val = parseInt(event.target.closest('.pro_list').querySelector('.bundle_box_cart.remove_btn').getAttribute('data-qty'));
    const data = {
        Qty: qty_val
    };


    let products = JSON.parse(localStorage.getItem('product_data'));
    if (!Array.isArray(products)) {
        products = [];
    }

    const index = products.findIndex(product => product.VarID === varId);

    if (index != -1) {
      if (qty_val === 1 ){
        products[index].Qty -= qty_val; 
      }
      else{
          products[index].Qty = qty_val; 
      }
    } 

    localStorage.setItem('product_data', JSON.stringify(products));
           cartItem();
        }
    });

  $('.product_options select').change(function() {
  $(this).closest('.Bundle_box_title').find('.custom_quantity').val('1');
  $(this).closest('.Bundle_box_title').find('.remove_btn').attr('data-qty','1');
  var value = $(this).find(":selected").val(); 
  var price = $(this).find(":selected").attr('var-price'); 
  $(this).closest('.Bundle_box_title').find('.add_btn').attr('data-varid',value);
  $(this).closest('.Bundle_box_title').find('.remove_btn').attr('data-varid',value);
  $(this).closest('.Bundle_box_title').find('.selling-plan-group .selling-plan-option').attr('data-variant-id',value);
  $(this).closest('.pro_list').attr('data-value',value);
  $(this).closest('.Bundle_box_title').find('p').text(price);
  $(this).closest('.pro_list').attr('data-price',price);
 });

  cartItem();



// local storage add class "active_item_box"
let products = JSON.parse(localStorage.getItem('product_data'));
if (Array.isArray(products)) {
    products.forEach(product => {
        let itemId = product.VarID;
        const itemSelectors = document.querySelectorAll('.pro_list');
        itemSelectors.forEach(item => {
            if (item.getAttribute('data-value') === itemId) {
                item.classList.add('active_item_box');
            }
        });
    });
}

  // reset btn click
  document.querySelector('.reset_all').addEventListener('click', function(event){   
    localStorage.removeItem("product_data");
    cartItem();
    event.preventDefault();
  });


  
});

